module.exports = __webpack_public_path__ + "media/images/pencil-blue-line-1bf448c3bb202305ccd781c72a3e0da2.png";